import {
  Button,
  Card,
  Center,
  Flex,
  Image,
  SimpleGrid,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useCallback, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { loginWithPassword as loginWithPasswordApi } from "../../api/login.ts";
import Logo from "../../components/Icons/Logo.tsx";
import appConfig from "../../config.ts";
import { AppRoute } from "../../constants";
import { LoginForm } from "./LoginForm.tsx";
import { useStyles } from "./LoginPage.styles.ts";

export default function LoginPage() {
  const { classes } = useStyles();

  const [loadingLoginPassword, setLoadingLoginPassword] =
    useState<boolean>(false);
  const navigate = useNavigate();

  const loginWithPassword = useCallback(
    (email: string, password: string) => {
      setLoadingLoginPassword(true);
      loginWithPasswordApi(email, password)
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          if (error.response?.status === 403) {
            navigate(AppRoute.AccessDenied);
          } else {
            notifications.show({
              title: "Login failed",
              message: "Please check your credentials",
              variant: "error",
            });
          }
        })
        .finally(() => {
          setLoadingLoginPassword(false);
        });
    },
    [navigate]
  );

  return (
    <SimpleGrid cols={2}>
      <Card w="100%" h="100%" radius="none" className={classes.leftWrapper}>
        <Center mx="auto" h="100vh" p={60} mt="auto" mb="auto">
          <Flex direction="column" align="left" gap={60}>
            <Title>Welcome to Aureous!</Title>
            <Text>
              The all in one solution to manage B2B trade credit. <br />
              Grow your business safely with confidence.
            </Text>
          </Flex>
        </Center>
      </Card>

      <Flex direction="column" align="center" justify="center" gap={24} p="20%">
        <Logo />

        <LoginForm
          loading={loadingLoginPassword}
          onSubmit={loginWithPassword}
        />

        <a
          href={`${appConfig.apiUrl}${AppRoute.Login}/federated/google`}
          className={classes.buttonLink}
        >
          <Button variant="outlineBlue" size="md" w="100%">
            <ThemeIcon className={classes.iconWrapper}>
              <Image
                height={20}
                width={20}
                src="https://www.svgrepo.com/show/475656/google-color.svg"
              />
            </ThemeIcon>
            Sign in with Google
          </Button>
        </a>
        <Flex gap={6}>
          <Link to={AppRoute.ForgotPassword} className={classes.link}>
            <Text weight="bolder">Forgot Password?</Text>
          </Link>
          Or
          <Link to={AppRoute.ForgotPassword} className={classes.link}>
            <Text weight="bolder">First time Log In?</Text>
          </Link>
        </Flex>
      </Flex>
    </SimpleGrid>
  );
}
